import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from "./sidebar/config.js";
import { mapGetters } from "vuex";
export default {
  data: function data() {
    return {
      config: config,
      value: "",
      menus: [],
      menuList: []
    };
  },
  created: function created() {
    this.getMenuList();
  },
  watch: {
    value: function value() {
      this.querySearch();
    },
    menu: function menu() {
      this.getMenuList();
    }
  },
  computed: _objectSpread({
    labelKey: function labelKey() {
      return this.website.menu.props.label || this.config.propsDefault.label;
    },
    pathKey: function pathKey() {
      return this.website.menu.props.path || this.config.propsDefault.path;
    },
    iconKey: function iconKey() {
      return this.website.menu.props.icon || this.config.propsDefault.icon;
    },
    childrenKey: function childrenKey() {
      return this.website.menu.props.children || this.config.propsDefault.children;
    }
  }, mapGetters(["menu", "website"])),
  methods: {
    handleEsc: function handleEsc() {
      this.$parent.isSearch = false;
    },
    getMenuList: function getMenuList() {
      var _this = this;

      var findMenu = function findMenu(list) {
        for (var i = 0; i < list.length; i++) {
          var ele = Object.assign({}, list[i]);

          if (_this.validatenull(ele[_this.childrenKey])) {
            _this.menuList.push(ele);
          } else {
            findMenu(ele[_this.childrenKey]);
          }
        }
      };

      this.menuList = [];
      findMenu(this.menu);
      this.menus = this.menuList;
    },
    querySearch: function querySearch() {
      var restaurants = this.menuList;
      var queryString = this.value;
      this.menus = queryString ? this.menuList.filter(this.createFilter(queryString)) : restaurants;
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        return restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect: function handleSelect(item) {
      this.handleEsc();
      this.value = "";
      this.$router.push({
        path: this.$router.$avueRouter.getPath({
          name: item[this.labelKey],
          src: item[this.pathKey]
        }, item.meta),
        query: item.query
      });
    }
  }
};